<!-- 单个商品组件 -->
<template>
  <div class="wrap-list-item goods" v-if="cart">
    <div class="goods-select">
      <van-checkbox
        v-model="isSelect"
        :disabled="+cart.is_can_select === 0 && !isCompile"
        :checked-color="theme['APP_theme_color']">
      </van-checkbox>
    </div>
    <div class="goods-img" :class="{'special-goods':+cart.is_online_pay_goods ===1}">
      <img @click="toDetail" :src="cart.thumbnail || $notImg" alt="">
    </div>
    <div class="goods-info" @click="toDetail">
      <p class="goods-info-name"><span v-if="cart.is_real_separate" class="tag">整件</span> {{cart.general_name}} {{cart.norms}}</p>
      <p class="goods-info-company"> {{cart.produce_unit}}</p>
      <p class="goods-info-batch" v-show="cart.batch_code.trim()"> 批号：{{cart.batch_code}}</p>
      <div class="goods-info-bottom" >
        <div class="info">
          <span class="price" v-if="type === 6">{{cart.realPrice}}积分</span>

          <span class="price"  v-else v-delivery-price><b>￥</b><span >{{float_change(cart.realPrice)}}</span></span>
          <span
            class="tag ml3"
            v-if="type !== 2 && typeInfo[type]">
            {{typeInfo[type]}}
          </span>
          <span
            class="tag ml3"
            v-if="type !== 2 && +cart.is_medicare === 1">
            医保
          </span>
          <del v-if="type === 2" class="del-price">￥{{float_change(cart.singlePrice)}}</del>
        </div>
        <stepper v-on="$listeners" v-bind="$attrs"  v-model="cart"/>
      </div>
      <div class="goods-info-tag" v-if="type === 2">
        <span class="tag">{{cart.is_seckill === 0 ? '特价': '秒杀'}}</span>
        <span class="tag ml3" v-if="+cart.is_medicare === 1">医保</span>
      </div>
    </div>
  </div>
</template>

<script>
import stepper from './stepper'
import { getTheme } from '@/assets/styles/theme.js'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    stepper
  },

  props: {
    item: {
      type: Object,
      default: () => null
    },
    selectedArr: {
      type: Array,
      default: () => []
    },
    type: {
      type: Number,
      default: 1
    },
    isCompile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checked: false,
      cart: this.item,
      typeInfo: {
        '1': '',
        '2': '特价',
        '3': '套装',
        '4': '满赠',
        '5': '赠品',
        '6': '兑换',
        '7': '抵现',
        '8': '预售'
      }
    }
  },
  computed: {
    ...mapGetters(['getSelectIdents']),
    theme () {
      return getTheme()
    },
    isSelect: {
      get: function () {
        return this.getSelectIdents.includes(this.cart.ident)
      },
      set: function (newVal) {
        this.SELECT_IDENTS({ ident: this.cart.ident, isSelect: newVal })
        this.$emit('loadCartData', true)
      }
    }
  },
  watch: {
    item: {
      deep: true,
      immediate: true,
      handler (val) {
        this.cart = JSON.parse(JSON.stringify(val))
      }
    },
    isCompile (newValue) {
      // 为了处理含嘛碱商品 在购物车不能别选中 但是编辑是能选中
      if (!newValue && +this.cart.is_can_select === 0 && this.getSelectIdents.includes(this.cart.ident)) {
        this.SELECT_IDENTS({ ident: this.cart.ident, isSelect: false })
      }
    }
  },

  created () {
  },

  methods: {
    ...mapActions(['SELECT_IDENTS']),
    toDetail () {
      const { cart, type } = this
      // location.href = `/product/detail?id=${cart.goods_id}&type=${type === 2 ? 2 : 1}`
      this.$router.push({
        path: '/goods-details',
        query: { goods_id: cart.goods_id, type: type }
      })
    }
  }
}

</script>
<style lang='scss' scoped>
.goods{
  display: flex;
  &-select{
    width: 18px;
    height: 65px;
    @include center();
    margin-right: 21px;
    /deep/{
      .van-checkbox__icon--checked .van-icon{
        background: var(--APP_theme_color);
        border-color: var(--APP_theme_color);
      }
    }
  }
  &-img{
    width: 65px;
    height: 65px;
    border-radius: 4px;
    overflow: hidden;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .special-goods{
    position: relative;
    &::before{
      display: inline-block;
      content: '';
      width: 41px;
      height: 41px;
      position: absolute;
      bottom: 0;
      right: 0;
      background: url('~@/assets/img/special-goods.png') no-repeat;
      background-size: 100%;
    }
  }
  &-info{
    flex: 1;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(229,229,229,1);
    margin-left: 15px;
    padding-bottom: 15px;
    p{
      @include ell()
    }
    &-name{
      font-size: 14px;
      color: #333333;
    }
    &-company{
      font-size: 12px;
      color: #777777;
    }
    &-batch{
      font-size: 12px;
      color: #999999;
    }
    &-bottom{
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      .price{
        font-size: 18px;
        display: flex;
        align-items: center;
        b{
          font-size: 12px;
        }
      }
      .info{
        display: flex;
        align-items: center;
      }
    }
  }
}
.tag{
  color: #FFFFFF;
  font-size: 12px;
  display:inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1px 3px;
  border-radius: 2px;
  background: #EC5F63;
}
.price{
  color: #EA2727;
}
.del-price{
  margin-left: 12px;
  color: #999999;
  font-size: 12px;
}
</style>
